/**
 * @param {*} eventRegistration
 * @returns The admission item object from event registration or null if there isn't one
 */
export const getSelectedAdmissionItem = eventRegistration => {
  if (!eventRegistration || !eventRegistration.productRegistrations) {
    return null;
  }

  const admissionItems = eventRegistration.productRegistrations
    .filter(product => product.productType === 'AdmissionItem')
    .filter(product => product.requestedAction === 'REGISTER');

  if (admissionItems.length === 0) {
    return null;
  }

  // If there is more than one admission item, the app is going to have other problems
  return admissionItems[0];
};

/**
 * @param {*} eventRegistration
 * @returns An array of the sessions that were selected by the registrant
 */
export const explicitlySelectedSessions = eventRegistration => {
  if (!eventRegistration.sessionRegistrations) {
    return [];
  }

  return Object.values(eventRegistration.sessionRegistrations)
    .filter(session => session.requestedAction === 'REGISTER')
    .filter(session => session.registrationSourceType === 'Selected');
};

/**
 * @param {*} eventRegistration
 * @returns An array of the sessions that were selected by the registrant or
 * are included by admissionItem
 */
export const allSelectedSessions = eventRegistration => {
  if (!eventRegistration.sessionRegistrations) {
    return [];
  }

  return Object.values(eventRegistration.sessionRegistrations)
    .filter(session => session.requestedAction === 'REGISTER')
    .filter(session => session.registrationSourceType === 'Selected' ||
      session.registrationSourceType === 'AdmissionItem');
};

/**
 * get the sessions which are opted for WAITLISTing.
 * @param eventRegistration
 * @returns {Array|*}
 */
export const getWaitlistedSessions = eventRegistration => {
  if (!eventRegistration.sessionWaitlists) {
    return [];
  }

  return Object.values(eventRegistration.sessionWaitlists)
    .filter(session => session.requestedAction === 'WAITLIST');
};

export const getRegistrationTypeId = eventRegistration => eventRegistration.registrationTypeId;

export const getRegistrationPathId = eventRegistration => eventRegistration.registrationPathId;

/**
 * filters out all the non-invitee registrations and sorts for display
 * @param allRegistrations
 * @param onlyLeaderAndNew whether we want only leader & new invitees added (don't want previously added group members)
 * @returns {*}
 */
export const getNonGuestRegistrationsForDisplay = (allRegistrations, onlyLeaderAndNew) => {
  const relevantRegistrations = allRegistrations.filter(reg => {
    const nonGuest = reg.attendeeType && reg.attendeeType !== 'GUEST';
    const groupLeader = reg.attendeeType && reg.attendeeType === 'GROUP_LEADER';
    const newlyAdded = reg.registrationStatus && reg.registrationStatus !== 'REGISTERED';

    if (onlyLeaderAndNew) {
      return groupLeader || (newlyAdded && nonGuest);
    }
    return nonGuest;
  });

  relevantRegistrations.sort((reg1, reg2) => {
    /**
     * Group leader is first in the list, then any attendees, sorted by their "displaySequence"
     */
    if (reg1.attendeeType && reg1.attendeeType === 'GROUP_LEADER') {
      return -1;
    }
    if (reg2.attendeeType && reg2.attendeeType === 'GROUP_LEADER') {
      return 1;
    }
    return reg1.displaySequence - reg2.displaySequence;
  });
  return relevantRegistrations;
};

export const getSelectedQuantityItems = (eventRegistration) => {
  if (!eventRegistration.quantityItemRegistrations) {
    return [];
  }
  return Object.values(eventRegistration.quantityItemRegistrations)
    .filter(quantityItem => quantityItem.quantity > 0);
};
